import { useEffect, useMemo } from 'react'

import { Option } from '@joor/design-system'
import debounce from 'lodash/debounce'

import { BrandStartOrderIds } from 'modals/OrderList/StartOrderModal/StartOrderModal.ids'

import { getDesignSystemOptionId } from '../../BrandStartOrderModal.formatters'
import messages from '../../BrandStartOrderModal.messages'
import { StyledDropdown } from './CollectionDropdown.styles'

const DEBOUNCE_TIME = 500

interface CollectionDropdownProps {
  loading: boolean
  options: Option[]
  value: string | null | undefined
  setSelectedCollectionId: (collectionId: string) => void
  changeCollectionSearchText: (searchText: string) => void
}

export const CollectionDropdown = ({
  loading,
  options,
  value,
  setSelectedCollectionId,
  changeCollectionSearchText,
}: CollectionDropdownProps) => {
  const selectedOption = useMemo(
    () =>
      options.find((option) => getDesignSystemOptionId(option) === value) ??
      null,
    [options, value],
  )

  const handleSelect = ({ selected }: { selected: Option }) => {
    setSelectedCollectionId(getDesignSystemOptionId(selected))
  }

  const handleInputChange = useMemo(
    () =>
      debounce((inputText: string) => {
        changeCollectionSearchText(inputText)
      }, DEBOUNCE_TIME),
    [changeCollectionSearchText],
  )

  useEffect(
    () => () => {
      handleInputChange.cancel?.()
    },
    [handleInputChange],
  )

  return (
    <StyledDropdown
      id={BrandStartOrderIds.CollectionOptions}
      testId={BrandStartOrderIds.CollectionOptions}
      labelId={BrandStartOrderIds.CollectionTitle}
      label={messages.selectLinesheet}
      options={options}
      value={selectedOption}
      translateOptions={false}
      onSelect={handleSelect}
      onInputChange={handleInputChange}
      isSearchable
      isLoading={loading}
      placeholder={messages.startTyping}
    />
  )
}
